export default ['configService', (configService) => {
    let property = undefined;

    const get = (param) => {
        if (!property) {
            property = configService.get('property');
        }

        return property[param];
    };

    return {
        get
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/services/property.service.js